export const ADMINISTRATOR = 'sif-sotl-admin';
export const APPROVER = 'sif-sotl-approver';
export const USER = 'sif-sotl-user';
